import { render, staticRenderFns } from "./ExternalVideoUrl.vue?vue&type=template&id=5a03f5f2&"
import script from "./ExternalVideoUrl.vue?vue&type=script&lang=js&"
export * from "./ExternalVideoUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports